import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import { Navbar } from 'react-bootstrap';
import { Card, Form, Button, Table, Dropdown, Modal } from 'react-bootstrap';
import axios from "axios";
import { var_api } from "../constant";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import sage from "../../images/splash/sage.jpeg";

const MembershipCardDesign = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [searchQuery, setSearchQuery] = useState('');
  const history = useHistory();
  
  // State for dropdowns
  const [customers, setCustomers] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedMembership, setSelectedMembership] = useState('');
  const [selectedCustomerName, setSelectedCustomerName] = useState('');
  const [selectedMembershipName, setSelectedMembershipName] = useState('');
  const [selectedrunningNo,setSelectedrunningNo]= useState('');
  const [selectedCustomerMobile, setSelectedCustomerMobile] = useState('');
  
  // State for card design
  const [cardNumber, setCardNumber] = useState('');
  const [issueDate, setIssueDate] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [generatedCards, setGeneratedCards] = useState([]);
  const [cardImagePreview, setCardImagePreview] = useState('');
  
  // Form fields for membership card
  const [activeStatus, setActiveStatus] = useState(1);
  const [cardId, setCardId] = useState('');
  const [errors, setErrors] = useState({});
  
  // State for edit modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCard, setEditingCard] = useState(null);
  const [editIssueDate, setEditIssueDate] = useState('');
  const [editExpiryDate, setEditExpiryDate] = useState('');
  const [editErrors, setEditErrors] = useState({});

  useEffect(() => {
    fetchCustomers();
    fetchMemberships();
    fetchGeneratedCards();
  }, [currentPage]);

  const selectedGeneratedCard = generatedCards.find(
    card =>
      card.customer_mobile == selectedCustomer &&
      card.membership_id == selectedMembership
  );

  const fetchCustomers = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
      const response = await axios.get(`${var_api}/api/get-customer-details`, {
        headers: {
          'Authorization': `${token}`
        }
      });
      setCustomers(response.data.customers || []);
    } catch (error) {
      console.error('Error fetching customers:', error);
      setCustomers([]);
    } finally {
      setIsLogin(false);
    }
  };

  const fetchMemberships = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
      const response = await axios.get(`${var_api}/api/membership-master/get-active`, {
        headers: {
          'Authorization': `${token}`
        }
      });
      setMemberships(response.data || []);
    } catch (error) {
      console.error('Error fetching memberships:', error);
      setMemberships([]);
    } finally {
      setIsLogin(false);
    }
  };

const fetchGeneratedCards = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
    const response = await axios.get(`${var_api}/api/cust-membership/get`, {
      headers: {
        'Authorization': `${token}`
      }
    });
    
    // Process the data to remove duplicates
    const processedData = processCardData(response.data || []);
    console.log('Processed cards:', processedData);
    setGeneratedCards(processedData);
    
  } catch (error) {
    console.error('Error fetching cards:', error);
    setGeneratedCards([]);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    }
  } finally {
    setIsLogin(false);
  }
};

// Add this function to process and deduplicate card data
const processCardData = (cards) => {
  if (!Array.isArray(cards)) return [];
  
  // Group by cust_membership_id
  const grouped = {};
  
  cards.forEach(card => {
    const id = card.cust_membership_id;
    if (!grouped[id]) {
      grouped[id] = [];
    }
    grouped[id].push(card);
  });
  
  // For each group, select the best record
  const result = [];
  Object.values(grouped).forEach(group => {
    if (group.length === 1) {
      result.push(group[0]);
    } else {
      // Multiple records for same membership - choose the most complete one
      // Strategy: Prefer records with complete customer information
      const completeRecords = group.filter(card => 
        card.customer_name && 
        card.customer_name !== '-' && 
        card.gender !== '-' && 
        card.dob !== '00-00-0000'
      );
      
      if (completeRecords.length > 0) {
        // Sort by most recent update
        completeRecords.sort((a, b) => 
          new Date(b.cm_updated_at || b.cd_updated_at) - 
          new Date(a.cm_updated_at || a.cd_updated_at)
        );
        result.push(completeRecords[0]);
      } else {
        // If no complete records, take the most recent one
        group.sort((a, b) => 
          new Date(b.cm_updated_at || b.cd_updated_at) - 
          new Date(a.cm_updated_at || a.cd_updated_at)
        );
        result.push(group[0]);
      }
    }
  });
  
  return result;
};

  // Edit Modal Functions
  const handleOpenEditModal = (card) => {
    setEditingCard(card);
    setEditIssueDate(card.start_date ? card.start_date.split('T')[0] : '');
    setEditExpiryDate(card.end_date ? card.end_date.split('T')[0] : '');
    setEditErrors({});
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingCard(null);
    setEditIssueDate('');
    setEditExpiryDate('');
    setEditErrors({});
  };

  const validateEditForm = () => {
    const newErrors = {};

    if (!editIssueDate) {
      newErrors.issueDate = 'Issue Date is required';
    }

    if (!editExpiryDate) {
      newErrors.expiryDate = 'Expiry Date is required';
    }

    if (editIssueDate && editExpiryDate && new Date(editIssueDate) > new Date(editExpiryDate)) {
      newErrors.expiryDate = 'Expiry Date must be after Issue Date';
    }

    return newErrors;
  };

const handleUpdateCardDates = async () => {
    const newErrors = validateEditForm();
    setEditErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const token = localStorage.getItem('token');
    setIsLogin(true);

    try {
      const response = await axios.put(
        `${var_api}/api/cust-membership/put/${editingCard.cust_membership_id}`,
        {
          membership_id: editingCard.membership_id, // Add membership_id from editingCard
          cust_mobile: editingCard.cust_mobile,    // Add cust_mobile from editingCard
          start_date: editIssueDate,
          end_date: editExpiryDate
        },
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Card dates updated successfully',
          confirmButtonColor: '#007500',
        });
        handleCloseEditModal();
        fetchGeneratedCards();
      }
    } catch (error) {
      console.error('Error updating card dates:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    } finally {
      setIsLogin(false);
    }
  };

  // Rest of your existing functions remain the same...
  const validateForm = () => {
    const newErrors = {};

    if (!selectedCustomer) newErrors.customer = 'Please select a customer';
    if (!selectedMembership) newErrors.membership = 'Please select a membership';
    if (!selectedCustomerMobile) newErrors.customerMobile = 'Customer mobile is required';
    if (!cardNumber) newErrors.cardNumber = 'Card Number is required';
    if (!issueDate) newErrors.issueDate = 'Issue Date is required';
    if (!expiryDate) newErrors.expiryDate = 'Expiry Date is required';

    if (issueDate && expiryDate && new Date(issueDate) > new Date(expiryDate)) {
      newErrors.expiryDate = 'Expiry Date must be after Issue Date';
    }

    return newErrors;
  };

  const generateCardNumber = () => {
    const cardNum = 'CARD-' + Math.floor(1000000000000000 + Math.random() * 9000000000000000).toString().slice(0, 16);
    setCardNumber(cardNum);
    
    const today = new Date().toISOString().split('T')[0];
    setIssueDate(today);
    
    const nextYear = new Date();
    nextYear.setFullYear(nextYear.getFullYear() + 1);
    setExpiryDate(nextYear.toISOString().split('T')[0]);
  };

  const createMembershipCard = async () => {
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const token = localStorage.getItem('token');
    setIsLogin(true);

    const selectedMembershipDetails = memberships.find(m => m.id == selectedMembership);
    
    const requestData = {
      membership_id: selectedMembership,
      cust_mobile: selectedCustomerMobile,
    };

    console.log('Sending POST data:', requestData);

    try {
      const response = await axios.post(
        `${var_api}/api/cust-membership/post`,
        requestData,
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          icon: 'success',
          text: 'Membership Card Created Successfully',
          confirmButtonColor: '#007500',
        });
      }

      fetchGeneratedCards();
      resetForm();

    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    } finally {
      setIsLogin(false);
    }
  };

const updateMembershipCard = async () => {
  const newErrors = validateForm();
  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) return;

  const token = localStorage.getItem('token');
  setIsLogin(true);

  const requestData = {
    cust_mobile: selectedCustomerMobile,
    membership_id: selectedMembership,
    start_date: issueDate,   
    end_date: expiryDate    
  };

  console.log('Sending PUT data:', requestData);

  try {
    const response = await axios.put(
      `${var_api}/api/cust-membership/put/${cardId}`,
      requestData,
      {
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Membership Card Updated Successfully',
        confirmButtonColor: '#007500',
      });
    }

    fetchGeneratedCards();
    resetForm();

  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error.response?.data?.error || 'Something went wrong!',
      confirmButtonColor: '#007500',
    });
  } finally {
    setIsLogin(false);
  }
};

  const handleStatusChange = async (card, newStatus) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);

    try {
      const response = await axios.put(
        `${var_api}/api/cust-membership/status/${card.id}`,
        { active_status: newStatus },
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Card Status Updated',
          confirmButtonColor: '#007500',
        });
      }

      fetchGeneratedCards();

    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    } finally {
      setIsLogin(false);
    }
  };

  const resetForm = () => {
    setSelectedCustomer('');
    setSelectedMembership('');
    setSelectedCustomerName('');
    setSelectedCustomerMobile('');
    setSelectedMembershipName('');
    setCardNumber('');
    setIssueDate('');
    setExpiryDate('');
    setQrCode('');
    setCardImagePreview('');
    setEditMode(false);
    setCardId('');
    setActiveStatus(1);
    setErrors({});
  };

  const handleEdit = (card) => {
    setEditMode(true);
    setCardId(card.id);
    setSelectedCustomer(card.customer_id || card.customer?.id || '');
    setSelectedMembership(card.membership_id || card.membership?.id || '');
    setSelectedCustomerName(card.customer_name || card.customer?.name || '');
    setSelectedCustomerMobile(card.cust_mobile || card.customer?.mobile_no || '');
    setSelectedMembershipName(card.membership_name || card.membership?.name || '');
    setCardNumber(card.card_number || '');
    setIssueDate(card.issue_date || '');
    setExpiryDate(card.expiry_date || '');
    setActiveStatus(card.active_status || 1);
    
    if (card.card_image_url) {
      setCardImagePreview(card.card_image_url);
    }
    
    setErrors({});
  };

  const handleCustomerSelect = (customerId, customerName, customerMobile) => {
    setSelectedCustomer(customerId);
    setSelectedCustomerName(customerName);
    setSelectedCustomerMobile(customerMobile);
  };

  const handleMembershipSelect = (membershipId, membershipName) => {
    setSelectedMembership(membershipId);
    setSelectedMembershipName(membershipName);
    
    if (!cardNumber) {
      generateCardNumber();
    }
  };

  // Filter generated cards
  const filteredCards = Array.isArray(generatedCards) && generatedCards.filter(card => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (card.card_number && card.card_number.toLowerCase().includes(searchLower)) ||
      (card.customer_name && card.customer_name.toLowerCase().includes(searchLower)) ||
      (card.cust_mobile && card.cust_mobile.toLowerCase().includes(searchLower)) ||
      (card.membership_name && card.membership_name.toLowerCase().includes(searchLower))
    );
  });

  // Apply pagination
  const paginatedCards = filteredCards.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render Membership Card Design Preview (same as before)
  const renderCardPreview = () => {
    if (!selectedCustomer || !selectedMembership) {
      return (
        <div className="text-center p-5 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
          <h5>Select a customer and membership to preview card design</h5>
        </div>
      );
    }

    const selectedMembershipDetails = memberships.find(m => m.id == selectedMembership);

    return (
      <div className="membership-card-preview" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <Card style={{
          width: '100%',
          minHeight: '260px',
          borderRadius: '18px',
          overflow: 'hidden',
          background: `linear-gradient(135deg, #0B3D2E 0%, #145C43 100%)`,
          color: 'white',
          boxShadow: '0 12px 35px rgba(0,0,0,0.35)',
          position: 'relative',
          padding: '20px',
          fontFamily: 'Arial, sans-serif'
        }}>
          {/* LOGO TOP LEFT */}
          <div style={{ position: 'absolute', top: 18, left: 20 }}>
            <img 
              src={sage} 
              alt="Logo"
              style={{
                width: '45px',
                height: '45px',
                borderRadius: '10px',
                objectFit: 'cover',
                boxShadow: '0 0 8px rgba(0,0,0,0.3)'
              }}
            />
          </div>

          {/* MEMBERSHIP NO TOP RIGHT */}
          <div style={{ position: 'absolute', top: 18, right: 20, textAlign: 'right' }}>
            <div style={{ fontSize: '10px', opacity: 0.75, letterSpacing: '0.5px' }}>
              MEMBERSHIP NO
            </div>
            <div style={{ fontSize: '15px', fontWeight: 600, marginTop: '3px' }}>
              {selectedGeneratedCard?.running_no || ""}
            </div>
          </div>

          {/* CENTER HEADING */}
          <div style={{ textAlign: 'center', marginTop: '70px', marginBottom: '18px' }}>
            <div style={{ fontSize: '22px', fontWeight: 700, marginTop: '-2px' }}>
              Sage
            </div>
            <div style={{ fontSize: '22px', fontWeight: 700, marginTop: '-2px' }}>
              LUXE Membership
            </div>
          </div>

          {/* CUSTOMER NAME */}
          <div style={{
            marginBottom: '16px',
            paddingBottom: '12px',
            borderBottom: '1px solid rgba(255,255,255,0.25)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '15px', opacity: 0.85, letterSpacing: '1px' }}>
              {selectedCustomerName}
            </div>
          </div>

          {/* ISSUE & EXPIRY DATE */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '13px',
            marginTop: '20px'
          }}>
            <div>
              <strong>Issue Date:</strong> {issueDate || "--/--/----"}
            </div>
            <div style={{ textAlign: 'right' }}>
              <strong>Expiry Date:</strong> {expiryDate || "--/--/----"}
            </div>
          </div>
        </Card>
      </div>
    );
  };

  return (
    <>
      {isLogin && <div>Loading...</div>}
      
      {/* Edit Date Modal */}
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Card Dates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editingCard && (
            <>
              <div className="mb-3">
                <strong>Customer:</strong> {editingCard.customer_name}
              </div>
              <div className="mb-3">
                <strong>Membership:</strong> {editingCard.membership_name}
              </div>
              <div className="mb-3">
                <strong>Card Number:</strong> {editingCard.running_no}
              </div>
              
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Issue Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={editIssueDate}
                    onChange={(e) => setEditIssueDate(e.target.value)}
                    isInvalid={!!editErrors.issueDate}
                  />
                  <Form.Control.Feedback type="invalid">
                    {editErrors.issueDate}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Expiry Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={editExpiryDate}
                    onChange={(e) => setEditExpiryDate(e.target.value)}
                    isInvalid={!!editErrors.expiryDate}
                  />
                  <Form.Control.Feedback type="invalid">
                    {editErrors.expiryDate}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEditModal}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleUpdateCardDates}
            style={{ backgroundColor: "rgb(89, 128, 71)", borderColor: "rgb(89, 128, 71)" }}
          >
            {isLogin ? 'Updating...' : 'Update Dates'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
        <Navbar.Brand href="#home">
          {/* <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} /> */}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link href="#" style={{ color: "black", fontSize: "25px", letterSpacing: "2px" }}>
              MEMBERSHIP CARD DESIGN
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
              <button className="btn" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white" }}>
                <i className="bi bi-house"></i> Go to home
              </button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <br />
      <br />
      <br />
      <br />
      <div style={{ margin: "auto", padding: "20px" }}>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
              <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>
                  {editMode ? 'Edit Membership Card' : 'Create Membership Card'}
                </h5>
                
                {/* Card Preview */}
                <div className="mb-4">
                  {renderCardPreview()}
                </div>

                <Form onSubmit={(e) => e.preventDefault()}>
                  {/* Customer Dropdown */}
                  <Form.Group controlId="formBasicCustomer" className="mt-3">
                    <Form.Label>Select Customer</Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle 
                        variant="outline-secondary" 
                        style={{ width: '100%', textAlign: 'left' }}
                      >
                        {selectedCustomerName 
                          ? `${selectedCustomerName} (${selectedCustomerMobile})`
                          : 'Select Customer'}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto', width: '100%' }}>
                        {customers.map((customer) => (
                          <Dropdown.Item 
                            key={customer.id}
                            onClick={() => handleCustomerSelect(customer.id, customer.customer_name, customer.customer_mobile)}
                          >
                            <div>
                              <div><strong>{customer.customer_name}</strong></div>
                              <small className="text-muted">{customer.customer_mobile}</small>
                            </div>
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>

                    {errors.customer && <p style={{ color: 'red' }}>{errors.customer}</p>}
                    
                    <Form.Control
                      type="hidden"
                      value={selectedCustomer}
                      required
                    />
                  </Form.Group>

                  {/* Membership Dropdown */}
                  <Form.Group controlId="formBasicMembership" className="mt-3">
                    <Form.Label>Select Membership</Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle 
                        variant="outline-secondary" 
                        style={{ width: '100%', textAlign: 'left' }}
                      >
                        {selectedMembershipName || 'Select Membership'}
                      </Dropdown.Toggle>
                      <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto', width: '100%' }}>
                        {memberships.map((membership) => (
                          <Dropdown.Item 
                            key={membership.id}
                            onClick={() => handleMembershipSelect(membership.id, membership.name)}
                          >
                            <div className="d-flex align-items-center">
                              <div
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  backgroundColor: membership.color_theme || '#598047',
                                  marginRight: '10px',
                                  borderRadius: '3px'
                                }}
                              />
                              <div>
                                <div><strong>{membership.name}</strong></div>
                                <small className="text-muted">
                                  ${membership.card_value_amt} - {membership.validity_days} days
                                </small>
                              </div>
                            </div>
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                    {errors.membership && <p style={{ color: 'red' }}>{errors.membership}</p>}
                    <Form.Control
                      type="hidden"
                      value={selectedMembership}
                      required
                    />
                  </Form.Group>

                  <div className="d-flex gap-2 mt-4">
                    <Button
                      variant="primary"
                      type="button"
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)", flex: 1 }}
                      onClick={createMembershipCard}
                      hidden={editMode}
                    >
                      {isLogin ? 'Creating...' : 'Create Card'}
                    </Button>
                    <Button
                      variant="primary"
                      type="button"
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)", flex: 1 }}
                      onClick={updateMembershipCard}
                      hidden={!editMode}
                    >
                      {isLogin ? 'Updating...' : 'Update Card'}
                    </Button>
                    <Button variant="outline-secondary" type="button" onClick={resetForm} style={{ flex: 1 }}>
                      Reset
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{ padding: "0px", margin: "0px" }}>
            <Card style={{ border: "none", maxWidth: "62rem", padding: "20px", margin: "auto", height: "auto", borderRadius: "20px", fontFamily: "Arial, Helvetica, sans-serif" }}>
              <h5 style={{ color: "rgb(89, 128, 71)", fontWeight: "bold" }}>
                Generated Membership Cards
                <span style={{ float: "right", fontSize: "17px", color: "black", fontWeight: "bold" }}>
                  <Form.Control
                    type="text"
                    placeholder="Search by card number, customer, or membership..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ width: '300px' }}
                  />
                </span>
              </h5>

              <Table responsive className="mt-3">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Card Number</th>
                    <th>Customer Name</th>
                    <th>Mobile</th>
                    <th>Membership</th>
                    <th>Issue Date</th>
                    <th>Expiry Date</th>
                    <th>Card Value</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
             <tbody>
  {paginatedCards.length > 0 ? (
    paginatedCards.map((card, index) => (
      <tr key={card.cust_membership_id || index}>
        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
        <td>
          <strong>{card.running_no || '---'}</strong>
        </td>
        <td>
          {card.customer_name || '---'}
        </td>
        <td>
          {card.cust_mobile || card.customer_mobile || '---'}
        </td>
        <td>
          <div className="d-flex align-items-center">
            {card.color_theme && (
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  backgroundColor: card.color_theme,
                  marginRight: '10px',
                  borderRadius: '3px',
                  border: '1px solid #ddd'
                }}
              />
            )}
            {card.membership_name || '---'}
          </div>
        </td>
        <td>
          {card.start_date ? new Date(card.start_date).toLocaleDateString() : '---'}
        </td>
        <td>
          {card.end_date ? new Date(card.end_date).toLocaleDateString() : '---'}
        </td>
        <td>
          ${parseFloat(card.card_value_amt || 0).toFixed(2)}
        </td>
        <td>
          <Form.Check
            type="switch"
            id={`card-status-switch-${card.cust_membership_id}`}
            checked={card.membership_active_status === 1}
            onChange={(e) =>
              handleStatusChange(card, e.target.checked ? 1 : 0)
            }
          />
        </td>
        <td><div className="d-flex gap-2">
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => {
                // View functionality
                const theme = card.color_theme || "#598047";
                const customerName = card.customer_name || "";
                const membershipName = card.membership_name || "";
                const running_no = card.running_no || "";
                
                Swal.fire({
                  width: 460,
                  showConfirmButton: true,
                  confirmButtonColor: "#007500",
                  title: '',
                  html: `
                    <div style="max-width:420px;margin:0 auto;">
                      <div style="
                        width:100%;
                        min-height:260px;
                        border-radius:18px;
                        background: linear-gradient(135deg, #0B3D2E 0%, #145C43 100%);
                        color:white;
                        padding:20px;
                        font-family: 'Arial', sans-serif;
                        position: relative;
                        box-shadow:0 12px 35px rgba(0,0,0,0.35);
                      ">
                        <div style="position:absolute; top:18px; left:20px;">
                          <img src="${sage}" 
                            style="width:45px; height:45px; border-radius:10px; object-fit:cover; box-shadow:0 0 8px rgba(0,0,0,0.3);" 
                          />
                        </div>
                        <div style="
                          position:absolute;
                          top:18px;
                          right:20px;
                          text-align:right;
                        ">
                          <div style="font-size:10px; opacity:0.75; letter-spacing:0.5px;">MEMBERSHIP NO</div>
                          <div style="font-size:15px; font-weight:600; margin-top:3px;">${running_no}</div>
                        </div>
                        <div style="text-align:center; margin-top:70px; margin-bottom:18px;">
                          <div style="font-size:22px; font-weight:700; margin-top:-2px;">Sage</div>
                          <div style="font-size:22px; font-weight:700; margin-top:-2px;">LUXE Membership</div>
                        </div>
                        <div style="
                          margin-bottom:16px;
                          padding-bottom:12px;
                          border-bottom:1px solid rgba(255,255,255,0.25);
                          text-align:center;
                        ">
                          <div style="font-size:20px; opacity:0.75; letter-spacing:0.5px;">
                            ${customerName}
                          </div>
                        </div>
                        <div style="
                          display:flex;
                          justify-content:space-between;
                          font-size:13px;
                          margin-top:20px;
                        ">
                          <div>
                            <strong>Issue Date:</strong> 
                            ${card.start_date ? new Date(card.start_date).toLocaleDateString() : ""}
                          </div>
                          <div style="text-align:right;">
                            <strong>Expiry Date:</strong> 
                            ${card.end_date ? new Date(card.end_date).toLocaleDateString() : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  `
                });
              }}
            >
              <i className="bi bi-eye"></i> 
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => handleOpenEditModal(card)}
            >
              <i className="bi bi-pencil"></i> 
            </Button>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" className="text-center">No membership cards found</td>
    </tr>
  )}
</tbody>
              </Table>
              {filteredCards.length > 0 && (
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={filteredCards.length}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  innerClass="pagination justify-content-end"
                  activeClass="active-pagination"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MembershipCardDesign;